<template>
    <md-field>
      <label for="userid">User ID</label>
        <md-select v-model="$store.state.settings.userId" name="userid" id="userid">
            <md-option value="3sq-david">3sq - David</md-option>
            <md-option value="3sq-regis">3sq - Regis</md-option>
            <md-option value="3sq-shannon">3sq - Shannon</md-option>
            <md-option value="joel">Joel</md-option>
            <md-option value="marlene-schwartz">Marlene Schwartz</md-option>
            <md-option value="sarah-mckee">Sarah McKee</md-option>
            <md-option value="eminet-gurganus">Eminet Gurganus</md-option>
            <!-- <md-option value="ashley-mills">Ashley Mills</md-option>
            <md-option value="casey-cunningham">Casey Cunningham</md-option>
            <md-option value="madeleine-aseltine">Madeleine Aseltine</md-option>
            <md-option value="tanvi-patel">Tanvi Patel</md-option> -->
            <!-- <md-option value="kirsten-carew">Kirsten Carew</md-option>
            <md-option value="kate-walder">Kate Walder</md-option>
            <md-option value="megan-jalberg">Megan Jalbert</md-option> -->
            <md-option value="erika-siracusa">Erika Siracusa</md-option>
            <md-option value="foodshare">Foodshare</md-option>
            <md-option value="pittsburgh">Pittsburgh</md-option>
            <md-option value="PHA">PHA</md-option>
        </md-select>
    </md-field>
</template>
<script>
export default {
  name: 'UserDropdown'
}
</script>